// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/index.css */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100vh;
  }
  
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
  
  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  
  /* Animations */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .fade-in {
    animation: fadeIn 0.3s ease-in-out;
  }
  
  /* Utility classes */
  .text-center {
    text-align: center;
  }
  
  .text-right {
    text-align: right;
  }
  
  .mt-1 { margin-top: 0.25rem; }
  .mt-2 { margin-top: 0.5rem; }
  .mt-3 { margin-top: 1rem; }
  .mt-4 { margin-top: 1.5rem; }
  .mt-5 { margin-top: 2rem; }
  
  .mb-1 { margin-bottom: 0.25rem; }
  .mb-2 { margin-bottom: 0.5rem; }
  .mb-3 { margin-bottom: 1rem; }
  .mb-4 { margin-bottom: 1.5rem; }
  .mb-5 { margin-bottom: 2rem; }
  
  .full-width {
    width: 100%;
  }
  
  .hidden {
    display: none !important;
  }
  
  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE;;gBAEY;IACZ,mCAAmC;IACnC,kCAAkC;IAClC,iBAAiB;EACnB;;EAEA;IACE;eACW;EACb;;EAEA,sBAAsB;EACtB;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,eAAe;EACf;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,kCAAkC;EACpC;;EAEA,oBAAoB;EACpB;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,QAAQ,mBAAmB,EAAE;EAC7B,QAAQ,kBAAkB,EAAE;EAC5B,QAAQ,gBAAgB,EAAE;EAC1B,QAAQ,kBAAkB,EAAE;EAC5B,QAAQ,gBAAgB,EAAE;;EAE1B,QAAQ,sBAAsB,EAAE;EAChC,QAAQ,qBAAqB,EAAE;EAC/B,QAAQ,mBAAmB,EAAE;EAC7B,QAAQ,qBAAqB,EAAE;EAC/B,QAAQ,mBAAmB,EAAE;;EAE7B;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX","sourcesContent":["/* src/index.css */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n  \n  body {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n      sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    min-height: 100vh;\n  }\n  \n  code {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n      monospace;\n  }\n  \n  /* Scrollbar styling */\n  ::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n  }\n  \n  ::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n  \n  ::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 4px;\n  }\n  \n  ::-webkit-scrollbar-thumb:hover {\n    background: #555;\n  }\n  \n  /* Animations */\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  .fade-in {\n    animation: fadeIn 0.3s ease-in-out;\n  }\n  \n  /* Utility classes */\n  .text-center {\n    text-align: center;\n  }\n  \n  .text-right {\n    text-align: right;\n  }\n  \n  .mt-1 { margin-top: 0.25rem; }\n  .mt-2 { margin-top: 0.5rem; }\n  .mt-3 { margin-top: 1rem; }\n  .mt-4 { margin-top: 1.5rem; }\n  .mt-5 { margin-top: 2rem; }\n  \n  .mb-1 { margin-bottom: 0.25rem; }\n  .mb-2 { margin-bottom: 0.5rem; }\n  .mb-3 { margin-bottom: 1rem; }\n  .mb-4 { margin-bottom: 1.5rem; }\n  .mb-5 { margin-bottom: 2rem; }\n  \n  .full-width {\n    width: 100%;\n  }\n  \n  .hidden {\n    display: none !important;\n  }\n  \n  .visually-hidden {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
